/* eslint-disable react-refresh/only-export-components */
import React from "react";

import { getOrganization } from "@/components/common/OrganizationSwitcher/utils";

import { fetchToken } from "@/utils/firebase/utils";
import { client } from "@/utils/remote";

const tokenPromise = fetchToken();
const AuthContext = React.createContext({
  token: "",
});
AuthContext.displayName = "AuthContext";

export const AuthProvider = (props: any) => {
  const token = tokenPromise.read();

  const value = React.useMemo(() => ({ token }), [token]);

  return <AuthContext.Provider value={value} {...props} />;
};

export function useAuth() {
  const context = React.useContext(AuthContext);
  if (context === undefined) {
    throw new Error(`useAuth must be used within a AuthProvider`);
  }
  return context;
}

export function useClient() {
  const { token } = useAuth();
  const selectedOrg = getOrganization();
  if (selectedOrg) {
    client.defaults.headers["x-act-as-org"] = selectedOrg.name;
  }
  client.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  return client;
}
